import { useEffect, useState } from "react";

export default function Toast() {
  const [msg, setMsg] = useState("");
  const [show, setShow] = useState(false);

  useEffect(() => {
    let timer: number | undefined;
    const onToast = (e: Event) => {
      setMsg((e as CustomEvent).detail || "已收到");
      setShow(true);
      window.clearTimeout(timer);
      timer = window.setTimeout(() => setShow(false), 2600);
    };
    window.addEventListener("chigua:toast", onToast);
    return () => {
      window.removeEventListener("chigua:toast", onToast);
      window.clearTimeout(timer);
    };
  }, []);

  return (
    <div
      className={`fixed bottom-6 left-1/2 -translate-x-1/2 z-[80] transition-all duration-300 ${
        show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      {msg && (
        <div className="flex items-center gap-2.5 px-4 py-3 rounded-lg bg-foreground-950 text-background-50 text-sm shadow-lg">
          <i className="ri-information-line text-accent-400"></i>
          {msg}
        </div>
      )}
    </div>
  );
}